import { mapState, mapGetters } from "vuex";
import {
  QUESTIONS_MODULE,
  APPLICATION_MODULE,
  STEPS_MODULE,
} from "@/store/types/module-types";

export default {
  computed: {
    ...mapState(STEPS_MODULE, ["currentStep", "applicationStartingStep"]),
    ...mapGetters(QUESTIONS_MODULE, {
      allQuoteQuestions: "allQuestions",
    }),
    ...mapGetters(APPLICATION_MODULE, {
      allApplicationQuestions: "allQuestions",
    }),
    allQuestions() {
      return this.currentStep < this.applicationStartingStep
        ? this.allQuoteQuestions
        : this.allApplicationQuestions;
    },
  },
};
